import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import Icon from '../../../components/AppIcon';

const barData = [
  { category: 'Flammables', Jan: 42, Feb: 38, Mar: 45 },
  { category: 'Corrosives', Jan: 28, Feb: 31, Mar: 29 },
  { category: 'Toxics', Jan: 15, Feb: 14, Mar: 16 },
  { category: 'Oxidisers', Jan: 9, Feb: 11, Mar: 10 },
  { category: 'Reactives', Jan: 6, Feb: 7, Mar: 5 },
];

const statusCards = [
  { label: 'Active High-Risk Permits', value: 8, icon: 'FileWarning', rag: 'amber', sub: '3 expiring today' },
  { label: 'Safety Critical Overrides', value: 2, icon: 'ShieldAlert', rag: 'red', sub: 'Requires sign-off' },
  { label: 'Process Deviations', value: 5, icon: 'GitBranch', rag: 'amber', sub: '2 unresolved' },
  { label: 'PRV Activations (MTD)', value: 1, icon: 'Gauge', rag: 'green', sub: 'Within threshold' },
];

const ragMap = {
  green: { bg: 'bg-emerald-500/10', text: 'text-emerald-500', badge: 'bg-emerald-500/20 text-emerald-400' },
  amber: { bg: 'bg-amber-500/10', text: 'text-amber-500', badge: 'bg-amber-500/20 text-amber-400' },
  red: { bg: 'bg-red-500/10', text: 'text-red-500', badge: 'bg-red-500/20 text-red-400' },
};

const ProcessSafetySection = () => {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center gap-2 mb-5">
        <div className="w-1 h-6 bg-orange-500 rounded-full" />
        <h2 className="text-base font-semibold text-foreground">Process Safety</h2>
        <span className="ml-auto text-xs text-muted-foreground bg-muted px-2 py-1 rounded-full">Q1 2025</span>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Grouped Bar Chart */}
        <div>
          <p className="text-xs font-medium text-muted-foreground mb-3 uppercase tracking-wide">Hazardous Chemical Inventory (tonnes)</p>
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={barData} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
              <XAxis dataKey="category" tick={{ fontSize: 10, fill: 'var(--color-muted-foreground)' }} />
              <YAxis tick={{ fontSize: 11, fill: 'var(--color-muted-foreground)' }} />
              <Tooltip contentStyle={{ background: 'var(--color-card)', border: '1px solid var(--color-border)', borderRadius: 8, fontSize: 12 }} />
              <Legend wrapperStyle={{ fontSize: 11 }} />
              <Bar dataKey="Jan" fill="#3b82f6" radius={[3, 3, 0, 0]} />
              <Bar dataKey="Feb" fill="#8b5cf6" radius={[3, 3, 0, 0]} />
              <Bar dataKey="Mar" fill="#06b6d4" radius={[3, 3, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
        {/* Status Cards */}
        <div>
          <p className="text-xs font-medium text-muted-foreground mb-3 uppercase tracking-wide">Process Safety Status</p>
          <div className="grid grid-cols-2 gap-3">
            {statusCards?.map((card) => {
              const rag = ragMap?.[card?.rag];
              return (
                <div key={card?.label} className={`${rag?.bg} border border-border rounded-lg p-3 flex flex-col gap-2`}>
                  <div className="flex items-center justify-between">
                    <Icon name={card?.icon} size={16} className={rag?.text} />
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${rag?.badge}`}>{card?.rag?.toUpperCase()}</span>
                  </div>
                  <p className="text-2xl font-bold text-foreground">{card?.value}</p>
                  <p className="text-xs font-medium text-foreground leading-tight">{card?.label}</p>
                  <p className="text-xs text-muted-foreground">{card?.sub}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessSafetySection;